module.exports = __webpack_public_path__ + "static/media/Duration.4e2da662.svg";